import React from 'react';
import { useElementHeight } from 'src/hooks';
import { BaseBox } from 'src/kit';

export const HeightMeter = ({ children, onChange, ...styledProps }) => {
  const ref = React.useRef();
  const height = useElementHeight(ref);
  React.useEffect(() => {
    onChange(height);
  }, [height, onChange]);

  return (
    <BaseBox ref={ref} {...styledProps}>
      {children}
    </BaseBox>
  );
};
